/**
 * DescriptionAddonSubscription component.
 */
import Addon from '@shared/classes/addon';
import ChannelUtils from '@shared/utils/channels';
import Content from '@shared/types/enums/content';
import Context from '@shared/components/utils/context/descriptionContext';
import Price from '@components/elements/addons/descriptionAddonPrice';
import Text from '@components/atoms/text/descriptionAddonSubscribedText';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useContext, useMemo } from 'react';

/**
 * Displays the subscription status of the current asset.
 */
export default function DescriptionAddonSubscription() {
  // Context
  const { asset } = useContext(Context);

  /**
   * Get the subscription status of the current asset.
   */
  const { addon, hasAddon, subscriptionText } = useMemo(() => {
    const addon = asset as Addon;
    const hasAddon = addon?.type === Content.ADDON ? addon.checkAddon() : false;
    const totalChannels =
      (addon?.plan && ChannelUtils.getPlanChannels(addon.plan)?.length) || 0;
    const subscriptionText = hasAddon ? (
      TranslationManager.get('COMPONENTS.RAILS.DESCRIPTION.ALREADY_SUBSCRIBED')
    ) : addon?.isFree ? (
      addon?.offerClaim ? (
        <>{addon.offerClaim}</>
      ) : (
        <>
          {' '}
          {TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_1')}
          <br></br>
          {TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_2') +
            (totalChannels && totalChannels > 1 ? ` ${totalChannels} ` : ' ') +
            TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_3')}
        </>
      )
    ) : null;
    return { addon, hasAddon, subscriptionText };
  }, [asset]);

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return hasAddon || addon?.isFree ? (
    subscriptionText ? (
      <Text>{subscriptionText}</Text>
    ) : null
  ) : (
    <Price asset={addon} />
  );
}
